import { render } from "./LinkStat.vue?vue&type=template&id=1963c70a"
import script from "./LinkStat.vue?vue&type=script&lang=js"
export * from "./LinkStat.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__